// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_lc-1";
export var rowFirst = "_lc-3";
export var rowLast = "_lc-5";
export var rowMiddle = "_lc-4";
export var ticketListScroll = "_lc-2";
export var ticketStack = "_lc-0";